import { createApp } from 'vue'
import Toast from '../components/Toast.vue'

let toastInstance = null
let toastContainer = null

const destroyToast = () => {
  if (toastInstance) {
    toastInstance.unmount()
    toastInstance = null
  }

  if (toastContainer?.parentNode) {
    toastContainer.parentNode.removeChild(toastContainer)
  }
  toastContainer = null
}

const showToast = (message, type = 'info', duration = 3000) => {
  // 如果已有 Toast，先移除
  destroyToast()

  // 创建容器
  const container = document.createElement('div')
  toastContainer = container
  document.body.appendChild(container)

  // 创建 Toast 实例
  toastInstance = createApp(Toast, {
    message,
    type,
    duration,
    onClose: () => {
      // 新提示可能已经替换了当前实例，只清理本次容器。
      if (toastContainer === container) {
        destroyToast()
      } else if (container.parentNode) {
        container.parentNode.removeChild(container)
      }
    }
  })

  toastInstance.mount(container)
}

export const toast = {
  success(message, duration) {
    showToast(message, 'success', duration)
  },
  error(message, duration) {
    showToast(message, 'error', duration)
  },
  info(message, duration) {
    showToast(message, 'info', duration)
  },
  warning(message, duration) {
    showToast(message, 'warning', duration)
  }
}

export default toast

